import React from 'react';
import { Link } from 'react-router-dom';
import { FaInstagram } from 'react-icons/fa';
import {
  MapPinIcon,
  PhoneIcon,
  EnvelopeIcon,
} from '@heroicons/react/24/outline';

const QUICK_LINKS = [
  { to: '/', label: 'Startseite' },
  { to: '/ueber-uns', label: 'Über mich' },
  { to: '/leistungen', label: 'Leistungen' },
  { to: '/galerie', label: 'Galerie' },
  { to: '/kontakt', label: 'Kontakt' },
];

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollAfterNav = () => {
    setTimeout(() => {
      try {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } catch (_e) {
        window.scrollTo(0, 0);
      }
    }, 100);
  };

  const openCookieSettings = () => {
    if (typeof window !== 'undefined' && window.openCookieSettings) {
      window.openCookieSettings();
    }
  };

  return (
    <footer className="relative mt-20 bg-wood-900 dark:bg-wood-950 text-cream-100/90 overflow-hidden">
      <div
        className="absolute inset-0 opacity-30"
        style={{
          backgroundImage:
            'radial-gradient(circle at 10% 20%, rgba(212,175,55,0.18), transparent 40%), radial-gradient(circle at 90% 80%, rgba(168,117,68,0.25), transparent 50%)',
        }}
        aria-hidden="true"
      />

      <div className="container relative pt-16 pb-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
          <div>
            <h3 className="font-display text-xl text-cream-50 mb-3">
              SS-craftedwithlove
            </h3>
            <p className="text-sm leading-relaxed text-cream-100/70">
              Individuelle Holzlasergravuren und einzigartige Handwerkskunst –
              persönliche Geschenke und Dekorationen nach Ihren Wünschen.
            </p>
            <div className="mt-5">
              <a
                href="https://www.instagram.com/ss.craftedwithlove/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-white/10 hover:bg-gold-500 hover:text-wood-900 transition-all"
                aria-label="Instagram-Profil von SS-craftedwithlove"
              >
                <FaInstagram />
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-display text-lg text-cream-50 mb-3">
              Schnellzugriff
            </h3>
            <ul className="space-y-2 text-sm">
              {QUICK_LINKS.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    onClick={scrollAfterNav}
                    className="text-cream-100/70 hover:text-gold-300 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-display text-lg text-cream-50 mb-3">Kontakt</h3>
            <ul className="space-y-3 text-sm text-cream-100/70">
              <li className="flex items-start gap-3">
                <MapPinIcon className="w-4 h-4 mt-0.5 flex-shrink-0 text-gold-300" />
                <span>Am Brunnenfeld 20, 86653 Daiting</span>
              </li>
              <li className="flex items-start gap-3">
                <PhoneIcon className="w-4 h-4 mt-0.5 flex-shrink-0 text-gold-300" />
                <a href="tel:+4915168580886" className="hover:text-gold-300">
                  +49 151 68580886
                </a>
              </li>
              <li className="flex items-start gap-3">
                <EnvelopeIcon className="w-4 h-4 mt-0.5 flex-shrink-0 text-gold-300" />
                <a
                  href="mailto:ss.craftedwithlove@t-online.de"
                  className="hover:text-gold-300 break-all"
                >
                  ss.craftedwithlove@t-online.de
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-display text-lg text-cream-50 mb-3">Rechtliches</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link
                  to="/impressum"
                  onClick={scrollAfterNav}
                  className="text-cream-100/70 hover:text-gold-300"
                >
                  Impressum
                </Link>
              </li>
              <li>
                <Link
                  to="/datenschutz"
                  onClick={scrollAfterNav}
                  className="text-cream-100/70 hover:text-gold-300"
                >
                  Datenschutzerklärung
                </Link>
              </li>
              <li>
                <button
                  type="button"
                  onClick={openCookieSettings}
                  className="text-cream-100/70 hover:text-gold-300 bg-transparent shadow-none p-0 normal-case"
                >
                  Cookie-Einstellungen
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-cream-100/10 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-xs text-cream-100/60">
          <p>
            &copy; {currentYear} SS-craftedwithlove · Stephan Schuchardt · Alle
            Rechte vorbehalten
          </p>
          <p>USt-ID: 111 / 271 / 30347</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
